import { Match } from '../types/api';

/**
 * De volgpagina van het live verslag, naast de publieke opstelling van het team. Met een
 * wedstrijd erbij het verslag van precies die wedstrijd, zoals /team/:publicId/:slug/:matchId
 * de opstelling van die wedstrijd is.
 */
export const publicLiveRoutePath = (publicId: string, slug: string, matchId?: number): string =>
  `/team/${publicId}/${slug}${matchId !== undefined ? `/${matchId}` : ''}/live`;

/** De wedstrijd waarvan het verslag nu loopt. */
export const runningLiveMatch = (matches: Match[]): Match | null =>
  matches.find((match) => match.liveStatus === 'running') ?? null;

/**
 * Welke wedstrijd de volgpagina toont. Met een wedstrijd in de link: die wedstrijd, ook als het
 * verslag nog niet begonnen is - dan staan de ploegen er al met 0-0. Zonder: het verslag dat nu
 * loopt, dan de huidige wedstrijd van de publieke opstelling, en anders het laatst afgesloten
 * verslag. De huidige wedstrijd is na het laatste fluitsignaal meestal nog dezelfde, dus een
 * ouder die de link dan opent ziet nog de eindstand.
 */
export const pickPublicLiveMatch = (matches: Match[], matchId?: number): Match | null => {
  if (matchId !== undefined) {
    return matches.find((match) => match.matchId === matchId) ?? null;
  }
  return (
    runningLiveMatch(matches) ??
    matches.find((match) => match.isCurrent) ??
    matches
      .filter((match) => match.liveStatus === 'ended')
      .sort((a, b) => (b.startTime ?? '').localeCompare(a.startTime ?? ''))[0] ??
    null
  );
};

/**
 * Welke wedstrijd de live-badge op de publieke opstelling krijgt. Een verslag dat nu loopt gaat
 * voor en is rood, ook als de kop een andere wedstrijd toont. Anders krijgt de getoonde
 * wedstrijd een grijze badge als die een afgelopen verslag heeft.
 */
export const badgeLiveMatch = (matches: Match[], shownMatchId: number | null): Match | null =>
  runningLiveMatch(matches) ??
  matches.find((match) => match.matchId === shownMatchId && match.liveStatus === 'ended') ??
  null;
